import { Stack } from "@fluentui/react"
import { PureComponent } from "react"
import { CardInfo } from "./components/cardInfo"
import { EnrollmentManager } from "./components/enrollment-manager"
import { ManagementDashboard } from "./components/management-dashboard"
import { MyAccount } from "./components/myaccount"
import { MyCard } from "./components/mycard"
import { PandaDocESign } from "./components/PandaDocESign"
import { ProviderManagement } from "./components/providerManagement"
import { ProviderSearch } from "./components/providerSearch"
import { Reports } from "./components/reports"
import { BordereauxAdjustments } from "./components/webResources/BordereauxAdjustments"
import { getUrlParameter } from "./services/helperService"

import { registerIcons, unregisterIcons } from "@fluentui/react/lib/Styling"
// Note: This approach works with any SVG icon set, not just @fluentui/react-icons-mdl2
import {
	AddIcon,
	BackIcon,
	CalendarIcon,
	CancelIcon,
	CheckMarkIcon,
	ChevronDownIcon,
	ClearIcon,
	ClosePaneIcon,
	DeleteIcon,
	DietPlanNotebookIcon,
	DocumentSetIcon,
	DownloadIcon,
	EditIcon,
	ErrorBadgeIcon,
	FolderOpenIcon,
	MoreVerticalIcon,
	NewFolderIcon,
	PageHeaderEditIcon,
	PageIcon,
	PeopleAddIcon,
	PeopleIcon,
	RefreshIcon,
	SearchIcon,
	SingleColumnEditIcon,
	UpIcon
} from "@fluentui/react-icons-mdl2"
import ContactUsForm from "./components/contactUsForm"
import { MemberVerify } from "./components/memberRegistration"
import { OpportunityMonitoring } from "./components/opportunity-monitoring"
import { SOBGenerator } from "./components/sobGenerator"
import { HouseholdMemberNotes } from "./components/webResources/householdMemberNotes"
import NonUWQuoteGenerator from "./components/webResources/nonUWQuoteGenerator"
import { OpportunityQuote } from "./components/webResources/OpportunityQuote"
import { OpportunityUploadCensus } from "./components/webResources/opportunityUploadCensus"
import { YearOverYearReport } from "./components/webResources/yearOverYearReport"
import { getToken } from "./providers/implicitGrantProvider"
import { MedicalQuestionnaireStart } from "./components/medicalQuestionnaireStart"
import { MedicalQuestionnaireForm } from "./components/medicalQuestionnaireForm"

// Note: For any icon name that has an icon already registered to it, you need to unregister it first before registering a new one
unregisterIcons([
	"ChevronDown",
	"People",
	"PeopleAdd",
	"MoreVertical",
	"Trash",
	"Edit",
	"Calendar",
	"Download",
	"SingleColumnEdit",
	"PageHeaderEdit",
	"DocumentSet",
	"Add",
	"Delete",
	"Search",
	"Download",
	"Calendar",
	"MoreVertical",
	"Back",
	"Up",
	"Page",
	"NewFolder",
	"Refresh",
	"Clear",
	"ClosePanel",
	"Cancel",
	"CheckMark",
	"ErrorBadge",
	"FolderOpen",
	"DietPlanNotebook"
])

registerIcons({
	icons: {
		People: <PeopleIcon />,
		Cancel: <CancelIcon />,
		ChevronDown: <ChevronDownIcon />,
		ClosePanel: <ClosePaneIcon />,
		PeopleAdd: <PeopleAddIcon />,
		MoreVertical: <MoreVerticalIcon />,
		Trash: <DeleteIcon />,
		Edit: <EditIcon />,
		Calendar: <CalendarIcon />,
		Download: <DownloadIcon />,
		SingleColumnEdit: <SingleColumnEditIcon />,
		//ExcelLogoInverse: <PeopleIcon />,
		PageHeaderEdit: <PageHeaderEditIcon />,
		DocumentSet: <DocumentSetIcon />,
		Add: <AddIcon />,
		Delete: <DeleteIcon />,
		Search: <SearchIcon />,
		Back: <BackIcon />,
		Up: <UpIcon />,
		Page: <PageIcon />,
		NewFolder: <NewFolderIcon />,
		Refresh: <RefreshIcon />,
		Clear: <ClearIcon />,
		CheckMark: <CheckMarkIcon />,
		ErrorBadge: <ErrorBadgeIcon />,
		FolderOpen: <FolderOpenIcon />,
		DietPlanNotebook: <DietPlanNotebookIcon />
	}
})

interface IComponentMapping {
	[x: string]: any
}

const componentMapping: IComponentMapping = {
	path: {
		"/management-tools/dashboard": ManagementDashboard,
		"/medical-questionnaire-start": MedicalQuestionnaireStart,
		"/medical-questionnaire": MedicalQuestionnaireForm,
		"/medical-questionnaire/confirmation": MedicalQuestionnaireForm,
		"/management-tools/opportunity-monitoring": OpportunityMonitoring,
		"/my-account": MyAccount,
		"/my-card": MyCard,
		"/card-info": CardInfo,
		"/provider-search": ProviderSearch,
		"/accounts/manage-providers": ProviderManagement,
		"/reports": Reports,
		"/member-registration": MemberVerify,
		"/plan-documents": SOBGenerator,
		"/panda-doc-esign": PandaDocESign,
		"/contact-us": ContactUsForm
	},
	webresourceName: {
		cw_enrollment_manager_react: EnrollmentManager,
		"cw_bordereaux-adjustments-form": BordereauxAdjustments,
		"cw_opportunity-quote": OpportunityQuote,
		"cw_year-over-year-report": YearOverYearReport,
		cw_household_member_notes: HouseholdMemberNotes,
		cw_nonuwquote: NonUWQuoteGenerator,
		cw_opportunity_census_upload: OpportunityUploadCensus
	}
}

export default class App extends PureComponent<any, any> {
	public render(): JSX.Element {
		let TagName = undefined
		let pathName = window.location.pathname.toLowerCase().replace(/\/$/, "")
		const webResourcesPathIndex = window.location.pathname.indexOf("/webresources/")
		if (webResourcesPathIndex !== -1) {
			const embeddedWebResourcePath = window.location.pathname.substring(webResourcesPathIndex + 14)
			TagName = componentMapping.webresourceName[embeddedWebResourcePath]
		} else if (window.top) {
			pathName = window.top.location.pathname.toLowerCase().replace(/\/$/, "")
			TagName = componentMapping.path[pathName]
			const webResourceName = getUrlParameter("webresourceName")
			if (webResourceName && webResourceName.length > 0) {
				pathName = webResourceName
				TagName = componentMapping.webresourceName[pathName]
			} else {
				//PORTAL
				if (pathName !== "/medical-questionnaire-start") getToken()
			}
		} else {
			return <span>window.top does not exist</span>
		}

		return (
			<div className="App">
				<Stack>{TagName ? <TagName /> : <>No route exists for {pathName}</>}</Stack>
			</div>
		)
	}
}
